import clsx from "clsx";
import Skeleton from "react-loading-skeleton";

import styles from "./GoogleAccountHandle.module.scss";

export const GoogleAccountHandleSkeleton = () => {
  return (
    <p className={styles.root}>
      <Skeleton
        width="1rem"
        height="1rem"
        containerClassName={clsx(styles.icon, styles.inlineBlock)}
      />{" "}
      <Skeleton
        width={240}
        height={18}
        containerClassName={styles.inlineBlock}
      />
    </p>
  );
};
